__turbopack_context__.v({
  "appear-slide-left": "AnimateServiceItem-module-scss-module__OpKmgW__appear-slide-left",
  "bounceTwice": "AnimateServiceItem-module-scss-module__OpKmgW__bounceTwice",
  "container": "AnimateServiceItem-module-scss-module__OpKmgW__container",
  "fade-in-bottom": "AnimateServiceItem-module-scss-module__OpKmgW__fade-in-bottom",
  "fade-in-left": "AnimateServiceItem-module-scss-module__OpKmgW__fade-in-left",
  "fade-in-right": "AnimateServiceItem-module-scss-module__OpKmgW__fade-in-right",
  "fadeIn": "AnimateServiceItem-module-scss-module__OpKmgW__fadeIn",
  "loader": "AnimateServiceItem-module-scss-module__OpKmgW__loader",
  "puff-in-center": "AnimateServiceItem-module-scss-module__OpKmgW__puff-in-center",
  "puff-in-left": "AnimateServiceItem-module-scss-module__OpKmgW__puff-in-left",
  "pulse": "AnimateServiceItem-module-scss-module__OpKmgW__pulse",
  "pulse-contact": "AnimateServiceItem-module-scss-module__OpKmgW__pulse-contact",
  "shake-bottom": "AnimateServiceItem-module-scss-module__OpKmgW__shake-bottom",
  "slide-again": "AnimateServiceItem-module-scss-module__OpKmgW__slide-again",
  "slide-in-right": "AnimateServiceItem-module-scss-module__OpKmgW__slide-in-right",
  "stepContent-entrance": "AnimateServiceItem-module-scss-module__OpKmgW__stepContent-entrance",
});
